import { render, staticRenderFns } from "./ClearFiltersBtn.vue?vue&type=template&id=3ae5916e&scoped=true&"
import script from "./ClearFiltersBtn.vue?vue&type=script&lang=js&"
export * from "./ClearFiltersBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae5916e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
